/**
 * Resistive voltage divider: Vout = Vin × R2 / (R1 + R2)
 * Accepts suffixes: 12V, 10k, 4.7k, etc.
 */

import React, { useState, useMemo } from 'react';
import { parseEngineering, inputClass, resultClass, labelClass, hintClass } from './parseEngineering';

const ts = () => new Date().toISOString();

const VoltageDivider = () => {
  const [vin, setVin] = useState('');
  const [r1, setR1] = useState('');
  const [r2, setR2] = useState('');

  console.log(`[${ts()}] [VoltageDivider] render`);

  const vinNum = useMemo(() => {
    const v = parseEngineering(vin);
    return v != null && v > 0 ? v : null;
  }, [vin]);
  const r1Num = useMemo(() => {
    const v = parseEngineering(r1);
    return v != null && v > 0 ? v : null;
  }, [r1]);
  const r2Num = useMemo(() => {
    const v = parseEngineering(r2);
    return v != null && v > 0 ? v : null;
  }, [r2]);

  const vout = useMemo(() => {
    if (vinNum == null || r1Num == null || r2Num == null) return null;
    return (vinNum * r2Num) / (r1Num + r2Num);
  }, [vinNum, r1Num, r2Num]);

  const ratio = useMemo(() => {
    if (r1Num == null || r2Num == null) return null;
    return r2Num / (r1Num + r2Num);
  }, [r1Num, r2Num]);

  return (
    <div className="space-y-4">
      <p className={hintClass}>
        Vout = Vin × R2 / (R1 + R2). Use suffixes: 12V, 10k, 4.7k, 100R, etc.
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <div>
          <label className={labelClass}>Vin</label>
          <input
            type="text"
            value={vin}
            onChange={(e) => setVin(e.target.value)}
            placeholder="e.g. 12V"
            className={inputClass}
          />
        </div>
        <div>
          <label className={labelClass}>R1</label>
          <input
            type="text"
            value={r1}
            onChange={(e) => setR1(e.target.value)}
            placeholder="e.g. 10k"
            className={inputClass}
          />
        </div>
        <div>
          <label className={labelClass}>R2</label>
          <input
            type="text"
            value={r2}
            onChange={(e) => setR2(e.target.value)}
            placeholder="e.g. 4.7k"
            className={inputClass}
          />
        </div>
      </div>
      {vout != null && (
        <div className={resultClass}>
          <div>
            <span className="text-gray-600 text-sm">Vout: </span>
            <span className="font-semibold text-gray-900">{vout.toFixed(4)} V</span>
          </div>
          {ratio != null && (
            <div>
              <span className="text-gray-600 text-sm">Ratio R2/(R1+R2): </span>
              <span className="font-semibold text-gray-900">{ratio.toFixed(4)}</span>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default VoltageDivider;
